module.exports = __webpack_public_path__ + "img/10.d638b25d.jpg";